module.exports = __webpack_public_path__ + "img/LLEGADO.0b669657.png";